import { Domain } from "./enums";
import z from "zod";
import { Member } from "./member";

export interface Hub {
  id: number;
  name: string;
  phone?: string;
  website?: string;
  logo?: string;
  domain: Domain;
  isPersonal: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface HubCreateInput {
  accountId: number;
  name: string;
  domain?: Domain;
  phone?: string;
  website?: string;
  logo?: string;
  isPersonal?: boolean;
}

export const hubCreateRequestSchema = z.object({
  name: z.string().trim().min(1),
  domain: z.nativeEnum(Domain),
  phone: z.string().trim().min(1).optional(),
  website: z.string().trim().min(1).optional(),
  logo: z.string().trim().min(1).optional(),
});
export type HubCreateRequest = z.infer<typeof hubCreateRequestSchema>;

export interface HubCreateResult {
  hub: Hub;
  member: Member;
}

export interface HubBranding {
  phone: string | null;
  website: string | null;
  addressLines: string[];
  logoContentCode: string | null;
}

export interface HubBrandingUpdateInput {
  phone?: string | null;
  website?: string | null;
  addressLines?: string[];
  logoContentCode?: string | null;
}
